import { useMemo, useState } from 'react';

import { ConversationLayoutContextValue } from './conversationLayout.types';

export const useConversationLayout = (): ConversationLayoutContextValue => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);

  return useMemo(
    () => ({
      isSidebarCollapsed,
      toggleSidebar: (value) => {
        const updatedValue = value ?? !isSidebarCollapsed;
        setIsSidebarCollapsed(updatedValue);
      },
    }),
    [isSidebarCollapsed]
  );
};
